import 'antd/dist/antd.css';
import React, { createElement, useCallback, useEffect } from 'react';
import _$1 from 'lodash';
import { DatePicker } from 'kts-xui';
import classnames from 'classnames';
import { registerFormField, connect, SchemaForm, createAsyncFormActions, LifeCycleTypes, FormButtonGroup, Reset, Submit } from '@formily/antd';
import { setup } from '@formily/antd-components';
import { AutoComplete, Input, Select, Row, Col, InputNumber, Modal, Menu, Tooltip, Tag, Button, Dropdown, Icon, Popover, message, TreeSelect } from 'antd';
import superagent from 'superagent';
import moment from 'moment';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var SdkConfig = /*#__PURE__*/function () {
  function SdkConfig() {
    _classCallCheck(this, SdkConfig);

    this._sdk = void 0;
    if (SdkConfig._instance) throw new Error('');
    SdkConfig._instance = this;
  }

  _createClass(SdkConfig, [{
    key: "sdk",
    get: function get() {
      return this._sdk;
    },
    set: function set(value) {
      this._sdk = value;
    }
  }], [{
    key: "instance",
    get: function get() {
      return SdkConfig._instance || new SdkConfig();
    }
  }]);

  return SdkConfig;
}();

SdkConfig._instance = void 0;
SdkConfig.token = '';

/**
 * 环境变量
 */
var NodeEnvType;

(function (NodeEnvType) {
  NodeEnvType["\u5F00\u53D1\u73AF\u5883"] = "debug";
  NodeEnvType["\u751F\u4EA7\u73AF\u5883"] = "production";
  NodeEnvType["\u6D4B\u8BD5\u73AF\u5883"] = "test";
  NodeEnvType["\u6F14\u793A\u73AF\u5883"] = "demo";
  NodeEnvType["\u817E\u8BAF\u6F14\u793A\u73AF\u5883"] = "tdemo";
})(NodeEnvType || (NodeEnvType = {}));

window['$$_kxl_env'] = window['$$_kxl_env'] ? window['$$_kxl_env'] : {
  DOMAIN: 'kingxunlian.com',
  IS_MOCK: true,
  NODE_ENV: 'debug'
};
window['$$_kxl_config'] = window['$$_kxl_config'] ? window['$$_kxl_config'] : {
  rootConfig: {
    API_URI: '//biz-gateway.{env}kingxunlian.com',
    APP_DOMAIN: 'kingxunlian.com',
    MEDIA_URL: '//image.test.kingxunlian.com/',
    PLATFORM_API_URI: '//api.{env}kingxunlian.com',
    SOCKET_URL: 'link-im.{env}kingxunlian.com'
  }
};
var env = window['$$_kxl_env'];
var config = window['$$_kxl_config'];
var NodeEnvTypeString = new Map([[NodeEnvType.开发环境, 'dev.'], [NodeEnvType.测试环境, 'test.'], [NodeEnvType.演示环境, 'demo.'], [NodeEnvType.腾讯演示环境, 'tdemo.'], [NodeEnvType.生产环境, '']]);
/** 请求头（全局） */

function serverDomain() {
  return config.rootConfig.API_URI.replace('{env}', NodeEnvTypeString.get(env.NODE_ENV));
}

var domain = serverDomain();

var getToken = function getToken() {
  var sdk = SdkConfig.instance.sdk;
  var cToken = sdk ? sdk.instance.user.cToken : SdkConfig.token;
  return cToken;
};
/**
 *
 * @param url
 * @param queryParams
 * @returns
 */


var httpGet = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, queryParams) {
    var _queryParams, params, res;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = queryParams || {};
            _queryParams = queryParams, params = _extends({}, _queryParams);
            _context.next = 4;
            return superagent.get(domain + url).set('Content-Type', 'application/json').set('Authorization', getToken()).query(_objectSpread2({}, params));

          case 4:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function httpGet(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var httpPost = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, postData) {
    var res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            postData = postData || {};
            _context2.next = 3;
            return superagent.post(domain + url).set('Content-Type', 'application/json').set('Authorization', getToken()).send(postData);

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function httpPost(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var _excluded = ["placeholder", "valueKey", "labelKeys"];

var BaseRef = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseRef, _React$Component);

  var _super = _createSuper(BaseRef);

  function BaseRef(props) {
    var _this;

    _classCallCheck(this, BaseRef);

    _this = _super.call(this, props);

    _this.init = function () {
      var value = _this.props.value;
      if (!value) return;

      _this.search(value);
    };

    _this.search = function (val) {
      var searchKey = _this.props.searchKey;

      var params = _defineProperty({}, searchKey, val);

      _this.setState({
        params: params
      }, _this.doRequest);
    };

    _this.doRequest = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$state, params, method, data, res, _res;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, params = _this$state.params, method = _this$state.method;
              data = _objectSpread2(_objectSpread2({}, params), _this.props.moreParams);

              if (!(method === 'get')) {
                _context.next = 9;
                break;
              }

              _context.next = 5;
              return httpGet(_this.props.requestUrl, data);

            case 5:
              res = _context.sent;

              if (res.body && res.body.ok) {
                _this.setState({
                  list: res.body.body.items || res.body.body
                });
              }

              _context.next = 13;
              break;

            case 9:
              _context.next = 11;
              return httpPost(_this.props.requestUrl, data);

            case 11:
              _res = _context.sent;

              if (_res.body && _res.body.ok) {
                _this.setState({
                  list: _res.body.body.items || _res.body.body
                });
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.onChange = function (value) {
      if (_$1.isFunction(_this.props.onChange)) {
        _this.props.onChange(value);
      }
    };

    _this.search = _$1.debounce(_this.search, 800);
    _this.state = {
      list: [],
      params: {},
      method: props.method || 'post'
    };
    return _this;
  }

  _createClass(BaseRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
    /**
     * 如果有初始值，那么要进行查询，然后显示数据
     * 初始值一般是id之类的值
     */

  }, {
    key: "render",
    value: function render() {
      var _this$state$list = this.state.list,
          list = _this$state$list === void 0 ? [] : _this$state$list;

      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          valueKey = _this$props.valueKey,
          labelKeys = _this$props.labelKeys,
          other = _objectWithoutProperties(_this$props, _excluded);

      var options = _$1.map(list, function (item) {
        return /*#__PURE__*/React.createElement(AutoComplete.Option, {
          value: _$1.get(item, valueKey)
        }, _$1.join(_$1.values(_$1.pick(item, labelKeys)), ' '));
      });

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(AutoComplete, _objectSpread2(_objectSpread2({}, other), {}, {
        dataSource: options,
        onSearch: this.search,
        onChange: this.onChange
      }), /*#__PURE__*/React.createElement(Input, {
        allowClear: true,
        placeholder: placeholder,
        onChange: this.search
      })));
    }
  }]);

  return BaseRef;
}(React.Component);

var CompanyRef = /*#__PURE__*/function (_React$Component) {
  _inherits(CompanyRef, _React$Component);

  var _super = _createSuper(CompanyRef);

  function CompanyRef() {
    _classCallCheck(this, CompanyRef);

    return _super.apply(this, arguments);
  }

  _createClass(CompanyRef, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(BaseRef, _objectSpread2({
        requestUrl: "/zone/company/customer/queryPage",
        searchKey: "customerName",
        labelKeys: ['customerName'],
        valueKey: "customerName",
        onChange: this.props.onChange,
        moreParams: {
          pageNum: 1,
          pageSize: 10
        }
      }, this.props));
    }
  }]);

  return CompanyRef;
}(React.Component);

var _excluded$1 = ["placeholder", "valueKey", "labelKeys", "splitsymbol"];
/**
 * 使用场景：select组件是先主动查询 不带分页
 */

var SelectRef = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectRef, _React$Component);

  var _super = _createSuper(SelectRef);

  function SelectRef(props) {
    var _this;

    _classCallCheck(this, SelectRef);

    _this = _super.call(this, props);

    _this.init = function () {
      _this.doRequest();
    };

    _this.doRequest = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var _this$state, params, method, searchKey, data, res, _res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$state = _this.state, params = _this$state.params, method = _this$state.method;
                searchKey = _this.props.searchKey;
                data = _objectSpread2(_objectSpread2(_objectSpread2({}, params), _this.props.moreParams), {}, _defineProperty({}, searchKey, value));

                if (!(method === 'get')) {
                  _context.next = 10;
                  break;
                }

                _context.next = 6;
                return httpGet(_this.props.requestUrl, data);

              case 6:
                res = _context.sent;

                if (res.body && res.body.ok) {
                  _this.setState({
                    list: res.body.body.items || res.body.body
                  });
                }

                _context.next = 14;
                break;

              case 10:
                _context.next = 12;
                return httpPost(_this.props.requestUrl, data);

              case 12:
                _res = _context.sent;

                if (_res.body && _res.body.ok) {
                  _this.setState({
                    list: _res.body.body.items || _res.body.body
                  });
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.onChange = function (value) {
      if (_$1.isFunction(_this.props.onChange)) {
        console.log(value);

        _this.props.onChange(value);
      }
    };

    _this.fetchApi = function (value) {
      _this.doRequest(value);
    };

    _this.state = {
      list: [],
      params: {},
      method: props.method || 'post'
    };
    _this.fetchApi = _$1.debounce(_this.fetchApi, 800);
    return _this;
  }

  _createClass(SelectRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$list = this.state.list,
          list = _this$state$list === void 0 ? [] : _this$state$list;

      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          valueKey = _this$props.valueKey,
          labelKeys = _this$props.labelKeys,
          splitsymbol = _this$props.splitsymbol,
          other = _objectWithoutProperties(_this$props, _excluded$1);

      var options = _$1.map(list, function (item) {
        // console.log(item, valueKey, _.get(item, valueKey));
        return /*#__PURE__*/React.createElement(Select.Option, {
          value: _$1.get(item, valueKey)
        }, _$1.join(_$1.values(_$1.pick(item, labelKeys)), splitsymbol || '/'));
      });

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(Select, _objectSpread2(_objectSpread2({}, other), {}, {
        placeholder: placeholder,
        value: this.props.value,
        onChange: this.onChange,
        onSearch: this.fetchApi
      }), options));
    }
  }]);

  return SelectRef;
}(React.Component);

var DepartmentRef = /*#__PURE__*/function (_React$Component) {
  _inherits(DepartmentRef, _React$Component);

  var _super = _createSuper(DepartmentRef);

  function DepartmentRef() {
    _classCallCheck(this, DepartmentRef);

    return _super.apply(this, arguments);
  }

  _createClass(DepartmentRef, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SelectRef, _objectSpread2({
        requestUrl: "/zone/company/department/query",
        searchKey: "name",
        labelKeys: ['name'],
        valueKey: "departmentId",
        onChange: this.props.onChange
      }, this.props));
    }
  }]);

  return DepartmentRef;
}(React.Component);

var BaseRef$1 = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseRef, _React$Component);

  var _super = _createSuper(BaseRef);

  function BaseRef(props) {
    var _this;

    _classCallCheck(this, BaseRef);

    _this = _super.call(this, props);

    _this.onChangeCapture = function () {
      var _this$state = _this.state,
          min = _this$state.min,
          max = _this$state.max;

      _this.props.onChange([min, max]);
    };

    _this.onMinChange = function (value) {
      _this.setState({
        min: value
      }, _this.onChangeCapture);
    };

    _this.onMaxChange = function (value) {
      _this.setState({
        max: value
      }, _this.onChangeCapture);
    };

    _this.state = {
      precision: _this.props.precision || 2,
      min: _this.props.value && _this.props.value[0],
      max: _this.props.value && _this.props.value[1]
    };
    return _this;
  }

  _createClass(BaseRef, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.value && (nextProps.value[0] !== nextState.min || nextProps.value[1] !== nextState.max)) {
        this.setState({
          min: nextProps.value[0],
          max: nextProps.value[1]
        });
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          min = _this$state2.min,
          max = _this$state2.max,
          precision = _this$state2.precision;
      return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        span: 11
      }, /*#__PURE__*/React.createElement(InputNumber, {
        style: {
          width: '100%'
        },
        precision: precision,
        value: min,
        onChange: this.onMinChange
      })), /*#__PURE__*/React.createElement(Col, {
        span: 2,
        style: {
          textAlign: 'center'
        }
      }, "-"), /*#__PURE__*/React.createElement(Col, {
        span: 11
      }, /*#__PURE__*/React.createElement(InputNumber, {
        style: {
          width: '100%'
        },
        precision: precision,
        value: max,
        onChange: this.onMaxChange
      })));
    }
  }]);

  return BaseRef;
}(React.Component);

var FormElement = {
  hasRegistered: false,
  components: [],
  registerAll: function registerAll() {
    if (!this.hasRegistered) {
      this.registerComp(this.companyRef);
      this.registerComp(this.baseRef);
      this.registerComp(this.numberRanger);
      this.registerComp(this.departmentRef);
      this.registerComp(this.selectRef);
    }
  },
  registerComp: function registerComp(registerOption) {
    if (!_.includes(this.components, registerOption.name)) {
      registerOption.register();
    }
  },
  companyRef: {
    code: "companyRef",
    name: "查询",
    register: function register() {
      registerFormField('companyRef', connect()(CompanyRef));
    }
  },
  baseRef: {
    code: "baseRef",
    name: "查询",
    register: function register() {
      registerFormField('baseRef', connect()(BaseRef));
    }
  },
  selectRef: {
    code: "selectRef",
    name: "部门管理",
    register: function register() {
      registerFormField('selectRef', connect()(SelectRef));
    }
  },
  departmentRef: {
    code: "departmentRef",
    name: "查询",
    register: function register() {
      registerFormField('departmentRef', connect()(DepartmentRef));
    }
  },
  numberRanger: {
    code: "numberRange",
    name: "金额",
    register: function register() {
      registerFormField('numberRange', connect()(BaseRef$1));
    }
  } // image_upload: {
  //     code: "image_upload",
  //     name: "图片上传",
  //     register: function () {
  //         registerFormField('image_upload', connect()(ImageUpload));
  //     }
  // },

};
setup();
FormElement.registerAll();

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".kts-form-rangePicker {\n  border-bottom: 1px solid #d9d9d9;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.kts-form-rangePicker:focus,\n.kts-form-rangePicker:hover {\n  border-color: #40a9ff;\n}\n";
styleInject(css_248z);

var _excluded$2 = ["onSubmit", "compact"];
var RangePicker = DatePicker.RangePicker;

var KtsForm = /*#__PURE__*/function (_React$Component) {
  _inherits(KtsForm, _React$Component);

  var _super = _createSuper(KtsForm);

  function KtsForm(props) {
    var _this;

    _classCallCheck(this, KtsForm);

    _this = _super.call(this, props);

    FormElement.registerAll();

    _this.state = {
      loading: true,
      billForm: {}
    };
    return _this;
  }

  _createClass(KtsForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        loading: false,
        billForm: {
          schema: formatSchema(this.props.schema)
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) return /*#__PURE__*/React.createElement("div", {
        style: {
          height: 300
        }
      }, "loading...");
      var billForm = this.state.billForm;

      var _this$props = this.props,
          onSubmit = _this$props.onSubmit,
          compact = _this$props.compact,
          other = _objectWithoutProperties(_this$props, _excluded$2);

      return /*#__PURE__*/React.createElement("div", {
        className: compact ? 'schema-form' : ''
      }, /*#__PURE__*/React.createElement(SchemaForm, _objectSpread2(_objectSpread2({}, other), {}, {
        components: {
          daterange: MyRangePicker
        },
        onSubmit: onSubmit,
        schema: _$1.get(billForm, 'schema')
      }), this.props.children));
    }
  }]);

  return KtsForm;
}(React.Component);

function formatSchema(schema) {
  try {
    var sum = _objectSpread2(_objectSpread2({}, schema), {}, {
      properties: _objectSpread2({}, schema.properties)
    });

    for (var key in sum.properties) {
      var item = sum.properties[key];

      if (item.enum) {
        sum.properties[key] = _objectSpread2({}, item);
        sum.properties[key]['x-props'] = _objectSpread2({}, sum.properties[key]['x-props']);
        sum.properties[key]['x-props']['dropdownClassName'] = classnames('kts-components-search advancedSearch-kts-form', sum.properties[key]['x-props']['dropdownClassName']);
      }
    }

    return sum;
  } catch (error) {
    return schema;
  }
}

function MyRangePicker(props) {
  var picker = props.picker;
  var onChange = React.useCallback(function (e) {
    try {
      props.onChange(e.map(function (e) {
        return e.format(picker === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD');
      }));
    } catch (error) {
      props.onChange(e);
    }
  }, [props.onChange]);
  var value = React.useMemo(function () {
    try {
      return props.value.map(function (e) {
        return e && moment(e);
      });
    } catch (error) {
      return props.value;
    }
  }, [props.value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "kts-form-rangePicker"
  }, /*#__PURE__*/React.createElement(RangePicker, _objectSpread2(_objectSpread2({}, props), {}, {
    allowClear: false,
    bordered: false,
    onChange: onChange,
    value: value
  })));
}

var _path;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgImgsearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    className: "img_search_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M985.781 918.594L820.773 765.526c27.373-32.973 49.655-69.577 66.437-109.258 22.933-54.219 34.56-111.795 34.56-171.13 0-59.333-11.627-116.91-34.56-171.13-22.143-52.354-53.838-99.365-94.2-139.729s-87.377-72.056-139.73-94.199c-54.219-22.933-111.795-34.561-171.13-34.561S365.24 57.148 311.022 80.08c-52.354 22.143-99.365 53.837-139.73 94.2s-72.057 87.375-94.2 139.73c-22.932 54.218-34.56 111.795-34.56 171.13 0 59.334 11.628 116.91 34.56 171.129 22.144 52.354 53.838 99.365 94.2 139.729s87.376 72.057 139.73 94.2c54.219 22.933 111.795 34.56 171.13 34.56s116.91-11.627 171.13-34.56c45.352-19.181 86.686-45.543 123.171-78.487l165.803 153.804a31.886 31.886 0 0021.756 8.54c8.593 0 17.163-3.442 23.467-10.238 12.019-12.956 11.26-33.205-1.698-45.223zm-503.63-57.836c-207.117 0-375.62-168.502-375.62-375.62 0-207.117 168.503-375.62 375.62-375.62s375.62 168.503 375.62 375.62c0 207.118-168.503 375.62-375.62 375.62z"
  })));
}

var _path$1;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgLower(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    className: "lower_svg__icon",
    viewBox: "0 0 1664 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    d: "M1515.904 342.144l-570.24 526.592c-49.92 46.08-213.632 93.184-330.624-12.416L66.688 349.952a126.976 126.976 0 010-189.824 153.856 153.856 0 01205.568 0L778.88 627.712l523.136-482.944a160.256 160.256 0 01213.76 0 132.096 132.096 0 010 197.376z"
  })));
}

var _path$2;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgDel(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    className: "del_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    d: "M799.201 874.4c0 34.4-28 62.4-62.368 62.4H287.199a62.497 62.497 0 01-62.4-62.4V212h574.4v662.403zM349.6 100c0-7.2 5.601-12.8 12.8-12.8h300.002c7.199 0 12.767 5.6 12.767 12.8v37.6H349.6v-37.6zm636.801 37.6H749.6v-37.6c0-48-39.2-87.2-87.2-87.2h-300a87.392 87.392 0 00-87.2 87.2v37.6H37.6c-20.8 0-37.6 16.8-37.6 37.6s16.8 37.6 37.6 37.6h112v661.6a137.6 137.6 0 00137.6 137.6h449.6a137.6 137.6 0 00137.6-137.6v-662.4h112c20.8 0 37.6-16.8 37.6-37.6s-16.8-36.8-37.6-36.8zM512 823.999c20.8 0 37.6-16.799 37.6-37.6V386.401c0-20.8-16.769-37.6-37.6-37.6-20.8 0-37.6 16.8-37.6 37.6v400c0 20.8 16.8 37.6 37.6 37.6m-175.201 0c20.8 0 37.6-16.8 37.6-37.6V386.399c0-20.799-16.8-37.6-37.6-37.6S299.2 365.6 299.2 386.4v400c.8 20.8 17.6 37.601 37.6 37.601m350.4 0c20.8 0 37.632-16.8 37.632-37.6V386.399c0-20.799-16.8-37.6-37.632-37.6-20.768 0-37.6 16.801-37.6 37.601v400c0 20.8 16.8 37.601 37.6 37.601",
    fill: "#515151"
  })));
}

var _path$3;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgFork(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    className: "fork_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    d: "M591.53 511.744l416.342-416.768a54.613 54.613 0 000-76.8l-2.304-2.304a54.443 54.443 0 00-76.63 0L512.513 433.237 96.256 15.957a54.443 54.443 0 00-76.63 0l-2.389 2.134a53.59 53.59 0 000 76.8l416.427 416.768L17.237 928.512a54.613 54.613 0 000 76.8l2.304 2.219a54.443 54.443 0 0076.63 0l416.426-416.854 416.342 416.854a54.443 54.443 0 0076.629 0l2.304-2.304a54.613 54.613 0 000-76.8L591.445 511.659z"
  })));
}

/**
 * 调用这个方法肯定是有预制模板需要设置
 * @param userKey 用户id
 * @param value
 *
 */
function setTemplatelist(userKey, appTab) {
  var templateList = getStorage('ktsfiltertemplate') || [];
  var userIndex = templateList.findIndex(function (item) {
    return item.userKey === userKey;
  });

  if (~userIndex) {
    var tabIndex = templateList[userIndex].data.findIndex(function (item) {
      return item === appTab;
    });

    if (~tabIndex) {
      return false;
    } else {
      templateList[userIndex].data.push(appTab);
      setStorage('ktsfiltertemplate', templateList);
      return true;
    }
  } else {
    var data = {
      userKey: userKey,
      data: [appTab]
    };
    setStorage('ktsfiltertemplate', [].concat(_toConsumableArray(templateList), [data]));
    return true;
  }
}
function setStorage(key, value) {
  return window.parent.localStorage.setItem(key, JSON.stringify(value));
}
function getStorage(key) {
  if (window.parent.localStorage.getItem(key)) {
    return JSON.parse(window.parent.localStorage.getItem(key) || '{}');
  } else {
    return undefined;
  }
}

var css_248z$1 = ".enter-block-shadow {\n  box-shadow: 0px 2px 4px 0px rgba(3, 0, 0, 0.2);\n  border-color: #d9d9d9;\n}\n.enter-block-shadow-disalbe {\n  box-shadow: none;\n  border-color: none;\n}\n.schema-form .ant-popover-inner-content {\n  padding: 0;\n}\n.schema-form .greyBackground {\n  margin: 0;\n  padding: 12px 16px;\n}\n.schema-form .greyBackground:hover {\n  background: #f1f1f1;\n}\n.schema-form .ant-btn-primary {\n  background-color: #0074ff;\n}\n.schema-form .ant-btn-primary-disabled,\n.schema-form .ant-btn-primary.disabled,\n.schema-form .ant-btn-primary[disabled],\n.schema-form .ant-btn-primary-disabled:hover,\n.schema-form .ant-btn-primary.disabled:hover,\n.schema-form .ant-btn-primary[disabled]:hover,\n.schema-form .ant-btn-primary-disabled:focus,\n.schema-form .ant-btn-primary.disabled:focus,\n.schema-form .ant-btn-primary[disabled]:focus,\n.schema-form .ant-btn-primary-disabled:active,\n.schema-form .ant-btn-primary.disabled:active,\n.schema-form .ant-btn-primary[disabled]:active,\n.schema-form .ant-btn-primary-disabled.active,\n.schema-form .ant-btn-primary.disabled.active {\n  background-color: #f5f5f5;\n}\n.schema-form .button-group .ant-btn-round {\n  border-radius: 32px;\n}\n.schema-form .button-group .ant-btn-background-ghost {\n  color: #fff;\n  background: transparent !important;\n  border-color: #fff;\n}\n.schema-form .button-group .ant-btn-background-ghost.ant-btn-primary {\n  color: #1890ff;\n  background-color: transparent;\n  border-color: #1890ff;\n  text-shadow: none;\n  border: 1px solid #1890ff !important;\n}\n.schema-form .ant-form-item {\n  margin-bottom: 0px;\n}\n.schema-form .ant-form-item .ant-form-item-label label:after {\n  content: '';\n}\n.schema-form .ant-form-item .ant-input {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n.schema-form .ant-form-item .ant-input:hover {\n  border-right-width: 0 !important;\n}\n.schema-form .ant-form-item .ant-input:focus {\n  border-right-width: 0 !important;\n  box-shadow: none;\n}\n.schema-form .ant-form-item .ant-input-number {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n.schema-form .ant-form-item .ant-input-number:hover {\n  border-right-width: 0 !important;\n}\n.schema-form .ant-form-item .ant-input-number:focus {\n  border-right-width: 0 !important;\n  box-shadow: none;\n}\n.schema-form .ant-form-item .ant-select-selection {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n.schema-form .ant-form-item .ant-select-selection:hover {\n  border-right-width: 0 !important;\n}\n.schema-form .ant-form-item .ant-select-selection:focus {\n  box-shadow: none;\n  border-right-width: 0 !important;\n}\n.schema-form .ant-tag {\n  border-radius: 10px;\n  border: none;\n  background-color: #f3f3f3;\n  color: #000000;\n}\n.schema-form .ant-input-number {\n  width: 100%;\n}\n.searchGroup {\n  display: flex;\n  gap: 10px;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  align-items: center;\n}\n.searchGroup .ant-input:not(.ant-input-disabled):focus,\n.searchGroup .ant-input:not(.ant-input-disabled):hover {\n  box-shadow: 0px 2px 4px 0px rgba(3, 0, 0, 0.2);\n  border-color: #d9d9d9;\n}\n.searchGroup .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover .ant-input:not(.ant-input-disabled) {\n  box-shadow: 0px 2px 4px 0px rgba(3, 0, 0, 0.2);\n  border-color: #d9d9d9;\n}\n.searchGroup .ant-input-affix-wrapper-focused:not(.ant-input-affix-wrapper-disabled),\n.searchGroup .ant-input-affix-wrapper:hover:not(.ant-input-affix-wrapper-disabled),\n.searchGroup .ant-input-affix-wrapper:focus:not(.ant-input-affix-wrapper-disabled) {\n  box-shadow: 0px 2px 4px 0px rgba(3, 0, 0, 0.2);\n  border-color: #d9d9d9;\n}\n.searchGroup .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n  box-shadow: none;\n}\n.searchGroup .ant-input,\n.searchGroup .ant-input-affix-wrapper .ant-input:not(:last-child) {\n  border-radius: 8px;\n  padding-left: 40px;\n  font-size: 12px;\n}\n.searchGroup .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: inherit;\n}\n.searchGroup .iconBox {\n  cursor: pointer;\n}\n.searchGroup .iconBoxPo {\n  position: relative;\n  right: -11px;\n  padding-right: 11px;\n  top: 2px;\n  padding-bottom: 4px;\n}\n.searchGroup .iconBox .searchIcon {\n  height: 16px;\n  width: 16px;\n}\n.searchGroup .iconBox .lowerIcon {\n  width: 30px;\n  height: 30px;\n  font-size: 12px;\n}\n.searchGroup .searchInput,\n.searchGroup .searchForm {\n  width: 500px;\n}\n.searchGroup .labelName {\n  display: inline-block;\n  margin-bottom: 0px;\n  vertical-align: middle;\n  padding-right: 3px;\n}\n.searchGroup .lowerIcon {\n  background: white;\n  transition: background 0.5s;\n  border-radius: 50%;\n  padding: 9px 8px;\n}\n.searchGroup .lowerIcon:hover {\n  background: #e6e6e6;\n}\n.searchGroup .lowerIconTransForm {\n  transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  /* IE 9 */\n  -moz-transform: rotate(180deg);\n  /* Firefox */\n  -webkit-transform: rotate(180deg);\n  /* Safari 和 Chrome */\n  -o-transform: rotate(180deg);\n  /* Opera */\n}\n.searchGroup .showBackground {\n  background: #e6e6e6;\n  border-radius: 50%;\n  padding: 9px 2px;\n}\n.searchGroup .hideBackground {\n  padding: 9px 2px;\n}\n.searchGroup .lowerIconTransFormInitial {\n  transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  /* IE 9 */\n  -moz-transform: rotate(0deg);\n  /* Firefox */\n  -webkit-transform: rotate(0deg);\n  /* Safari 和 Chrome */\n  -o-transform: rotate(0deg);\n  /* Opera */\n}\n.searchGroup .searchTag {\n  display: inline-block;\n  background-color: #e4e4e4;\n  height: 20px;\n  padding: 0 12px;\n  color: #000;\n  line-height: 20px;\n  border-radius: 10px;\n  border: none;\n  font-size: 12px;\n  margin: 0 8px 0 0;\n  opacity: 1;\n  transition: all 0.3s;\n  display: flex;\n  align-items: center;\n}\n.searchGroup .searchTag .searchTagText {\n  margin-right: 10px;\n  max-width: 190px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.searchGroup .searchTag .anticon {\n  font-size: 10px;\n}\n.hiddenArrow {\n  padding-top: 5px;\n}\n.hiddenArrow .ant-popover-arrow {\n  display: none;\n}\n.searchForm {\n  padding: 20px;\n  cursor: default;\n  background-color: #ffffff;\n  overflow-y: auto;\n  max-height: 500px;\n  border-radius: 8px;\n}\n.searchForm label {\n  color: #000000;\n}\n.searchForm .ant-input-number-focused,\n.searchForm .ant-input-number:hover,\n.searchForm .ant-select-open .ant-select-selection {\n  box-shadow: none;\n  border-right: none;\n}\n.searchForm:hover {\n  background-color: #ffffff !important;\n}\n.searchForm .btnBox {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 5px;\n}\n.searchForm .btnBox .btn {\n  width: 80px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  font-size: 14px;\n  color: #ffffff;\n  background-color: #0074ff;\n  border-radius: 18px;\n  border: 1px solid #0074ff;\n  margin-left: 20px;\n  cursor: pointer;\n}\n.searchForm .btnBox .btnColor {\n  border: 1px solid #121212;\n  background-color: #121212;\n}\n.searchForm .ant-checkbox-group,\n.searchForm .ant-radio-group {\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n.searchForm .ant-checkbox-group label,\n.searchForm .ant-radio-group label {\n  flex: none;\n  width: 33%;\n}\n.kts-components-search .searchForm {\n  padding-bottom: 60px;\n}\n.kts-components-search .kts-components-searchFoot {\n  background: #fff;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 10px;\n  z-index: 1;\n}\n.kts-components-search.advancedSearch-kts-form .ant-select-dropdown-menu-item-selected,\n.kts-components-search.advancedSearch-kts-form .ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled),\n.kts-components-search.advancedSearch-kts-form .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {\n  background-color: #f3f3f3;\n}\n";
styleInject(css_248z$1);

var confirm = Modal.confirm;
var actions = createAsyncFormActions();

function SearchGroup(props) {
  var filterOnly = props.filter || false;
  var sdk = SdkConfig.instance.sdk;
  var tableKey = props.tableKey;
  var setId = React.useMemo(function () {
    return props.setId;
  }, [props.setId]);
  var clearId = React.useMemo(function () {
    return props.clearId;
  }, [props.clearId]);
  var passData = React.useMemo(function () {
    return props.passData;
  }, [props.passData]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      lowerStatus = _React$useState2[0],
      setLowerStatus = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      editable = _React$useState4[0],
      setEdit = _React$useState4[1];

  var _React$useState5 = React.useState(''),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      templateName = _React$useState6[0],
      setName = _React$useState6[1];

  var _React$useState7 = React.useState(props.initialValues || {}),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      formData = _React$useState8[0],
      setFormData = _React$useState8[1];
  /**
   * 字体高亮
   */


  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      hightlight = _React$useState10[0],
      setHighLight = _React$useState10[1];

  var _React$useState11 = React.useState([]),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      templateList = _React$useState12[0],
      setList = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      formInit = _React$useState14[0],
      setInit = _React$useState14[1];

  var _React$useState15 = React.useState([]),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      filterTag = _React$useState16[0],
      setFilterTag = _React$useState16[1];

  var _React$useState17 = React.useState([]),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      hoverTip = _React$useState18[0],
      setHover = _React$useState18[1];

  var queryUrl = '/zone/company/filtertemplate/query';
  var updateUrl = '/zone/company/filtertemplate/update';
  var deleteUrl = '/zone/company/filtertemplate/delete';
  var insertUrl = '/zone/company/filtertemplate/insert';
  var listinsertUrl = '/zone/company/filtertemplate/batch/insert';
  var getAppKey = useCallback(function () {
    var appKey = sdk ? sdk.instance.getAppKey : props.appKey;
    return appKey;
  }, [sdk]);

  var classNameSearchForm = function classNameSearchForm() {
    return props.searchFormClassName ? "searchForm ".concat(props.searchFormClassName) : 'searchForm';
  };

  useEffect(function () {
  }, [clearId]);
  var getTemplate = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var tabId, exist;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!props.pre_data) {
              getData();
            } else {
              if (tableKey) {
                tabId = getAppKey() + '-' + props.tableKey;
                exist = setTemplatelist(props.userId || sdk && sdk.instance.user.userInfo.cUserId, tabId);

                if (!exist) {
                  getData();
                } else {
                  createTemplateList(props.pre_data);
                }
              }
            }

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);

  var getData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var params, data, list;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                appKey: getAppKey(),
                tableKey: props.tableKey
              };
              _context2.next = 3;
              return doRequest(queryUrl, params);

            case 3:
              data = _context2.sent;

              if (data.body.ok) {
                if (data.body.body) {
                  list = data.body.body.map(function (item) {
                    return _objectSpread2(_objectSpread2({}, item), {}, {
                      filterTemplateContent: JSON.parse(item.filterTemplateContent)
                    });
                  });
                  setList(list);
                }
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var doRequest = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, data) {
      var res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return httpPost(url, data);

            case 2:
              res = _context3.sent;
              return _context3.abrupt("return", res);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function doRequest(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var showHover = function showHover() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, hoverTip.length > 0 && hoverTip.map(function (item, key) {
      return /*#__PURE__*/React.createElement("div", {
        key: key
      }, item.label, ":", item.value);
    }));
  };

  var onTagOver = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(record) {
      var data, list;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              data = record.filterTemplateContent;
              _context4.next = 3;
              return creatTag(data);

            case 3:
              list = _context4.sent;
              setHover(list);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onTagOver(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   *
   * @param data 表单数据
   * @returns 返回tag标签数组
   */


  var creatTag = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {
      var schema, filterEnum, filters, _loop, i, _ret;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // const schema = await actions.getFormSchema() as any; 由于表单还未初始化所以无法显示tag，必须用下面的方式获取schema
              schema = props.children.props.schema;
              filterEnum = schema.properties;
              filters = [];

              _loop = function _loop(i) {
                var item = void 0;

                if (Array.isArray(data[i])) {
                  if (filterEnum[i] && filterEnum[i].enum) {
                    var targetItems = filterEnum[i].enum.filter(function (record) {
                      var index = data[i].findIndex(function (element) {
                        return element === record.value;
                      });
                      return !!~index;
                    });
                    var labels = targetItems.map(function (item) {
                      return item.label;
                    });
                    item = {
                      label: filterEnum[i].title,
                      value: labels.join(),
                      key: i
                    };
                  } else {
                    item = {
                      label: filterEnum[i].title,
                      value: data[i].join(),
                      key: i
                    };
                  }
                } else {
                  if (filterEnum[i] && filterEnum[i].enum) {
                    var targetItem = filterEnum[i].enum.find(function (record) {
                      return record.value === data[i];
                    });
                    item = {
                      label: filterEnum[i].title,
                      value: targetItem && targetItem.label,
                      key: i
                    };
                  } else {
                    if (filterEnum[i]) {
                      item = {
                        label: filterEnum[i].title,
                        value: data[i],
                        key: i
                      };
                    } else {
                      //字段解构，大概是时间范围值
                      var keys = Object.keys(filterEnum);
                      var keyIndex = keys.findIndex(function (item) {
                        return ~item.indexOf(i);
                      });

                      if (~keyIndex) {
                        item = {
                          label: filterEnum[keys[keyIndex]].title,
                          value: data[i],
                          key: i
                        };
                      } else {
                        //可能是一些分页信息
                        return "continue";
                      }
                    }
                  }
                }

                filters.push(item);
              };

              _context5.t0 = regeneratorRuntime.keys(data);

            case 5:
              if ((_context5.t1 = _context5.t0()).done) {
                _context5.next = 12;
                break;
              }

              i = _context5.t1.value;
              _ret = _loop(i);

              if (!(_ret === "continue")) {
                _context5.next = 10;
                break;
              }

              return _context5.abrupt("continue", 5);

            case 10:
              _context5.next = 5;
              break;

            case 12:
              return _context5.abrupt("return", filters);

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function creatTag(_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * 显示查询条件明细
   * @param data 查询对象
   */
  // const filterText = async data => {
  //   const list = await creatTag(data);
  //   setFilterTag(list);
  // };


  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var list;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return creatTag(formData);

            case 2:
              list = _context6.sent;
              setFilterTag(list);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }, [formData]);
  /**
   * 设置表单数据
   * @param data 表单初始数据
   */
  //  const setFormField = data => {
  //   actions.reset();
  //   for (let i in data) {
  //     actions.setFieldState(i, state => {
  //       state.value = data[i];
  //     });
  //   }
  // };

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var _loop2, i;

      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (lowerStatus) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return");

            case 2:
              _context7.next = 4;
              return actions.reset({
                forceClear: true
              });

            case 4:
              _loop2 = function _loop2(i) {
                actions.setFieldState(i, function (state) {
                  state.value = formData[i]; // console.log(formData[i])
                });
              };

              for (i in formData) {
                _loop2(i);
              }

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }, [formData, lowerStatus]);
  useEffect(function () {
    if (setId !== 0) {
      var data = _objectSpread2(_objectSpread2({}, passData), formData);

      var filter = dirtData(data); // setFormField(filter);

      setFormData(filter); // filterText(filter);
    }
  }, [setId, passData]);

  var clonefilterText = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(data) {
      var filter;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              data = _objectSpread2(_objectSpread2({}, data), formData);
              filter = dirtData(data); // setFormField(filter);

              setFormData(filter); // filterText(filter);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function clonefilterText(_x5) {
      return _ref8.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (tableKey) {
      getTemplate();
    }
  }, []);
  /**
   * 初始化设置tag标签和input输入框
   */

  useEffect(function () {
    if (props.initialValues) {
      // filterText(props.defaultValue);
      setFormData(props.initialValues);
    }
  }, [props.initialValues]);
  /**
   * 用于搜索input输入的时候同步更新form表单input
   */

  useEffect(function () {
  }, [formData[props.defaultKey]]);

  var classNameSearchInput = function classNameSearchInput() {
    return props.searchInputClassName ? "searchInput ".concat(props.searchInputClassName) : 'searchInput';
  };

  var resetBtnClassName = function resetBtnClassName() {
    return props.resetBtnClassName ? "btn btnColor ".concat(props.resetBtnClassName) : "btn btnColor";
  };

  var subBtnClassName = function subBtnClassName() {
    return props.subBtnClassName ? "btn ".concat(props.subBtnClassName) : "btn";
  };

  var lowerHandler = function lowerHandler() {
    setLowerStatus(!lowerStatus);
  };

  var searchInputHandler = function searchInputHandler(e) {
    e.nativeEvent.stopImmediatePropagation();
    bubblingData(formData); // setFormField(formData);
    // console.log(22);
    // filterText(formData);

    setLowerStatus(false);
  };
  /**
   * 清空tag标签
   */


  var removeAll = function removeAll() {
    var values = {};
    (props.protectedKeys || []).forEach(function (e) {
      values[e] = formData[e];
    });
    setFormData(values);
    props.searchFormSubmit(values);
  };

  var closeFilterTag = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(record) {
      var restData;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              restData = dirtData(_objectSpread2(_objectSpread2({}, formData), {}, _defineProperty({}, record.key, null)));
              setFormData(restData); // filterText(restData);

              bubblingData(restData); // await actions.setFieldState(record.key, state => {
              //   state.value = null;
              //   delete state.value;
              // });

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function closeFilterTag(_x6) {
      return _ref9.apply(this, arguments);
    };
  }();

  var clearForm = function clearForm() {
    if (formInit) {
      actions.reset();
      console.log('clear');
      setFormData({});
    } // filterText({});
    // props.searchFormSubmit({});

  };

  var onInputClickHandler = function onInputClickHandler(e) {
    e.nativeEvent.stopImmediatePropagation();

    if (e.keyCode !== 13) {
      return;
    } // filterText(dirtData(formData));


    bubblingData(formData);
    setLowerStatus(false);
  };
  /**
   * 搜索框监听函数
   */


  var inputChangeHandler = function inputChangeHandler(e) {
    e.nativeEvent.stopImmediatePropagation();

    var searchObject = _defineProperty({}, props.defaultKey, e.target.value);

    setFormData(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), searchObject);
    });
  };
  /**
   * 点击筛选后触发
   * @param data 表单数据
   */


  var onSubmitSchema = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(data) {
      var filter;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              console.log(data);
              filter = dirtData(data);
              extendsFields(data);
              setFormData(filter); // props.searchFormSubmit(filter);

              bubblingData(filter);
              window.setTimeout(function () {
                lowerHandler();
              }, 100); // filterText(filter);

            case 6:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function onSubmitSchema(_x7) {
      return _ref10.apply(this, arguments);
    };
  }();
  /**
   * 表单数据冒泡
   */


  var bubblingData = function bubblingData(data) {
    props.searchFormSubmit(extendsFields(data));
  };

  var extendsFields = function extendsFields(data) {
    var schema = props.children.props.schema;
    var filterEnum = schema.properties;

    var rebornData = _objectSpread2({}, data);

    for (var i in data) {
      if (filterEnum[i] && filterEnum[i].type === 'daterange') {
        if (Array.isArray(data[i]) && filterEnum[i]['x-props'] && filterEnum[i]['x-props'].extendsFields) {
          rebornData[filterEnum[i]['x-props'].extendsFields[0]] = data[i][0];
          rebornData[filterEnum[i]['x-props'].extendsFields[1]] = data[i][1];
        }
      }
    }

    return rebornData;
  };

  var dirtData = function dirtData(data) {
    for (var i in data) {
      if (data[i] === '' || data[i] === undefined || data[i] === null || Array.isArray(data[i])) {
        if (Array.isArray(data[i])) {
          if (data[i].length === 0) {
            delete data[i];
          } else {
            var empty = data[i].every(function (item) {
              return item === undefined;
            });

            if (empty) {
              delete data[i];
            }
          }
        } else {
          delete data[i];
        }
      }
    }

    return data;
  };

  var checkEdit = function checkEdit() {
    if (JSON.stringify(dirtData(formData)) !== '{}') {
      setInputAlive(true);
    } else {
      message.warn('请输入筛选条件!');
    }
  };

  var setInputAlive = function setInputAlive(value) {
    setEdit(value);
  };

  var createTemplateList = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(list) {
      var data;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              list = list.map(function (item) {
                return _objectSpread2(_objectSpread2({}, item), {}, {
                  filterTemplateContent: JSON.stringify(item.data),
                  appKey: getAppKey(),
                  tableKey: props.tableKey
                });
              });
              _context11.next = 3;
              return doRequest(listinsertUrl, list);

            case 3:
              data = _context11.sent;
              getTemplate();

            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function createTemplateList(_x8) {
      return _ref11.apply(this, arguments);
    };
  }();

  var createTemplate = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(data) {
      var index, params, _data;

      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              index = templateList.findIndex(function (item) {
                return item.templateName === templateName;
              });
              params = {
                appKey: getAppKey(),
                tableKey: props.tableKey,
                templateName: templateName,
                filterTemplateContent: data
              };

              if (!~index) {
                _context13.next = 7;
                break;
              }

              lowerHandler();
              confirm({
                title: '名称已存在，覆盖已有模板？',
                onOk: function () {
                  var _onOk = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                    var data;
                    return regeneratorRuntime.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _context12.next = 2;
                            return doRequest(updateUrl, params);

                          case 2:
                            data = _context12.sent;

                            if (data.body.ok) {
                              getTemplate();
                            } else {
                              message.error(data.body.status.description);
                            }

                          case 4:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12);
                  }));

                  function onOk() {
                    return _onOk.apply(this, arguments);
                  }

                  return onOk;
                }(),
                onCancel: function onCancel() {}
              });
              _context13.next = 11;
              break;

            case 7:
              _context13.next = 9;
              return doRequest(insertUrl, params);

            case 9:
              _data = _context13.sent;

              if (_data.body.ok) {
                getTemplate();
              } else {
                message.error(_data.body.status.description);
              }

            case 11:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function createTemplate(_x9) {
      return _ref12.apply(this, arguments);
    };
  }();
  /**
   * 保存筛选模板
   * 空格无法保存
   * @param data 筛选条件数据
   */


  var saveTemplate = function saveTemplate(data) {
    if (!templateName || !templateName.trim()) {
      message.warning('请输入筛选名字,并且名字不能是空格');
    } else {
      createTemplate(dirtData(data));
      onCancel();
    }
  };
  /**
   * 退出筛选输入模式
   */


  var onCancel = function onCancel() {
    setInputAlive(false);
    setName('');
  };
  /**
   * 筛选模式名字变化监听
   * @param e
   */


  var onNameChange = function onNameChange(e) {
    setName(e.target.value);
  };
  /**
   * 删除tag
   * @param record 当前tag
   */


  var closeTag = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(record) {
      var selectName, params, data;
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              selectName = record.templateName;
              params = {
                appKey: getAppKey(),
                tableKey: props.tableKey,
                templateName: selectName
              };
              _context14.next = 4;
              return doRequest(deleteUrl, params);

            case 4:
              data = _context14.sent;

              if (data.body.ok) {
                getTemplate();
              }

            case 6:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function closeTag(_x10) {
      return _ref13.apply(this, arguments);
    };
  }();
  /**
   * 选择tag
   * @param record
   */


  var onTagSelect = function onTagSelect(record) {
    var selectValue = record.filterTemplateContent;
    setFormData(selectValue);
    bubblingData(selectValue);
  };

  var showMenu = /*#__PURE__*/React.createElement(Menu, {
    className: "kts-components-search"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNameSearchForm(),
    style: {
      width: "".concat(props.width, "px"),
      whiteSpace: 'normal'
    }
  }, /*#__PURE__*/React.cloneElement(props.children, {
    onSubmit: onSubmitSchema,
    clearForm: clearForm,
    clonefilterText: clonefilterText,
    effects: function effects($, action) {
      $(LifeCycleTypes.ON_FORM_MOUNT).subscribe( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                setInit(true);

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      })));
      $(LifeCycleTypes.ON_FIELD_VALUE_CHANGE).subscribe(function (fieldState) {
        var searchObject = _defineProperty({}, fieldState.name, fieldState.value);

        var data = _objectSpread2(_objectSpread2({}, formData), searchObject);

        data = dirtData(data);

        if (JSON.stringify(dirtData(data)) !== '{}') {
          setHighLight(true);
        } else {
          setHighLight(false);
        }
      });

      if (props.children.props.effects) {
        props.children.props.effects($, action);
      }
    },
    actions: actions
  }, [/*#__PURE__*/React.createElement("div", {
    className: "kts-components-searchFoot"
  }, /*#__PURE__*/React.createElement(Row, {
    gutter: 8,
    key: 0
  }, /*#__PURE__*/React.createElement(Col, {
    span: 24,
    style: {
      marginBottom: 14,
      whiteSpace: 'normal'
    }
  }, templateList.length > 0 && templateList.map(function (item, key) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      key: key,
      title: showHover
    }, /*#__PURE__*/React.createElement(Tag, {
      onMouseOver: function onMouseOver() {
        onTagOver(item);
      },
      style: {
        marginTop: 10
      },
      onClick: function onClick() {
        onTagSelect(item);
      },
      closable: true,
      onClose: function onClose(e) {
        e.preventDefault();
        closeTag(item);
      }
    }, item.templateName));
  })), tableKey && /*#__PURE__*/React.createElement(Col, {
    span: 11
  }, editable ? /*#__PURE__*/React.createElement(Input, {
    placeholder: "\u540D\u5B57\u4E0D\u80FD\u4E3A\u7A7A\u683C",
    onChange: onNameChange,
    maxLength: 15
  }) : /*#__PURE__*/React.createElement("span", {
    style: {
      lineHeight: '32px',
      color: hightlight ? '#0074FF' : '#999999',
      cursor: hightlight ? 'pointer' : 'auto'
    },
    onClick: checkEdit
  }, "\u4FDD\u5B58\u4E3A\u9884\u5236\u7B5B\u9009")), !tableKey && /*#__PURE__*/React.createElement(Col, {
    span: 11
  }), /*#__PURE__*/React.createElement(Col, {
    span: 13,
    style: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(FormButtonGroup, null, !editable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Reset, {
    shape: "round",
    type: "primary",
    ghost: true,
    className: resetBtnClassName(),
    style: {
      marginRight: 20,
      width: 80
    },
    forceClear: true
  }, "\u6E05\u7A7A"), /*#__PURE__*/React.createElement(Submit, {
    shape: "round",
    className: subBtnClassName(),
    style: {
      width: 80
    }
  }, "\u7B5B\u9009")), editable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    shape: "round",
    type: "primary",
    ghost: true,
    style: {
      marginRight: 20,
      width: 80
    },
    onClick: onCancel
  }, "\u8FD4\u56DE"), /*#__PURE__*/React.createElement(Submit, {
    shape: "round",
    disabled: templateName ? false : true,
    onSubmit: saveTemplate,
    style: {
      width: 80
    }
  }, ' ', "\u4FDD\u5B58"))))))])));

  var hovermenu = function hovermenu() {
    if (!lowerStatus) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          minWidth: 120,
          margin: '-12px -16px'
        },
        className: "schema-form"
      }, /*#__PURE__*/React.createElement("p", {
        onClick: lowerHandler,
        className: "greyBackground"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          cursor: 'pointer'
        }
      }, "\u624B\u52A8\u7B5B\u9009")), templateList.length > 0 && templateList.map(function (item, key) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          placement: "right",
          key: key,
          title: showHover
        }, /*#__PURE__*/React.createElement("p", {
          onMouseOver: function onMouseOver() {
            onTagOver(item);
          },
          className: "greyBackground",
          onClick: function onClick() {
            onTagSelect(item);
          },
          key: key
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            cursor: 'pointer'
          }
        }, item.templateName)));
      }));
    } else {
      return false;
    }
  };

  var onFocusHandler = function onFocusHandler(e) {
    if (filterOnly) {
      e.target.blur();
    }
  };

  var prefixDom = function prefixDom() {
    if (filterOnly) {
      return /*#__PURE__*/React.createElement("div", {
        className: "iconBox",
        onClick: searchInputHandler
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "filter"
      }));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "iconBox",
        onClick: searchInputHandler
      }, /*#__PURE__*/React.createElement(Icon, {
        style: {
          fontSize: 20
        },
        component: SvgImgsearch
      }));
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "searchGroup"
  }, props.extra, /*#__PURE__*/React.createElement(Input, {
    autoComplete: "off",
    readOnly: inputReadOnly(props.children.props.schema.properties, props.defaultKey),
    onChange: inputChangeHandler,
    value: formData[props.defaultKey],
    onKeyUp: onInputClickHandler,
    onFocus: onFocusHandler,
    className: classNameSearchInput(),
    style: {
      width: props.width,
      height: props.height
    },
    placeholder: props.placeholder,
    prefix: prefixDom(),
    suffix: Object.keys(props.children.props.schema.properties).length <= 1 ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(Dropdown, {
      key: 1,
      overlayStyle: {
        width: "".concat(props.width, "px")
      },
      overlay: showMenu,
      visible: lowerStatus,
      trigger: ['click'],
      placement: "bottomRight",
      onVisibleChange: lowerHandler
    }, /*#__PURE__*/React.createElement(React.Fragment, null, lowerStatus && /*#__PURE__*/React.createElement("div", {
      className: "iconBox iconBoxPo",
      onClick: lowerHandler
    }, /*#__PURE__*/React.createElement(Icon, {
      className: lowerStatus ? "lowerIcon lowerIconTransForm showBackground" : "lowerIcon lowerIconTransFormInitial hideBackground",
      component: SvgLower
    })), !lowerStatus && templateList.length > 0 && /*#__PURE__*/React.createElement(Popover, {
      placement: "bottomLeft",
      content: hovermenu(),
      overlayClassName: "hiddenArrow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "iconBox iconBoxPo",
      onClick: lowerHandler
    }, /*#__PURE__*/React.createElement(Icon, {
      className: lowerStatus ? "lowerIcon lowerIconTransForm showBackground" : "lowerIcon lowerIconTransFormInitial hideBackground",
      component: SvgLower
    }))), !lowerStatus && templateList.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "iconBox iconBoxPo",
      onClick: lowerHandler
    }, /*#__PURE__*/React.createElement(Icon, {
      className: lowerStatus ? "lowerIcon lowerIconTransForm showBackground" : "lowerIcon lowerIconTransFormInitial hideBackground",
      component: SvgLower
    }))))
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    span: 24,
    className: props.compact ? 'schema-form' : '',
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, filterTag.length > 0 && filterTag.map(function (item, key) {
    var text = item.label + ':' + item.value;
    return /*#__PURE__*/React.createElement(Tooltip, {
      key: key,
      title: text
    }, /*#__PURE__*/React.createElement("span", {
      className: "searchTag"
    }, /*#__PURE__*/React.createElement("span", {
      className: "searchTagText",
      style: {
        marginRight: 10
      }
    }, text), (props.protectedKeys || []).indexOf(item.key) < 0 && /*#__PURE__*/React.createElement(Icon, {
      onClick: function onClick() {
        closeFilterTag(item);
      },
      component: SvgFork
    })));
  }), filterTag.length > 0 && /*#__PURE__*/React.createElement(Icon, {
    onClick: removeAll,
    component: SvgDel
  }))));
}

function inputReadOnly(properties, defaultKey) {
  if (!defaultKey) return true;
  if (!properties[defaultKey]) return true;
  if (properties[defaultKey].type === 'string' && !properties[defaultKey].enum) return false;
  if (properties[defaultKey].type === 'number' && !properties[defaultKey].enum) return false;
  return true;
}

var _defs, _path$4;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgLower$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    className: "lower_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("style", null))), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    stroke: "#000",
    strokeWidth: 30,
    d: "M1011.2 311.467c-17.067-17.067-42.667-17.067-59.733 0L512 725.333 72.533 311.467c-17.066-17.067-42.666-17.067-59.733 0-17.067 17.066-17.067 42.666 0 59.733l439.467 413.867c17.066 17.066 38.4 25.6 59.733 25.6s42.667-8.534 59.733-25.6L1011.2 371.2c17.067-17.067 17.067-42.667 0-59.733z"
  })));
}

var TreeNode = TreeSelect.TreeNode;

var KtsTreeSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(KtsTreeSelect, _React$Component);

  var _super = _createSuper(KtsTreeSelect);

  function KtsTreeSelect(props) {
    var _this;

    _classCallCheck(this, KtsTreeSelect);

    _this = _super.call(this, props);

    _this.onChange = function (value) {
      _this.setState({
        value: value
      });

      _this.props.onChange(value);
    };

    _this.state = {};
    return _this;
  }

  _createClass(KtsTreeSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        value: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TreeSelect, _objectSpread2(_objectSpread2({
        showSearch: true,
        value: this.state.value,
        treeNodeLabelProp: "showtitle",
        treeNodeFilterProp: "title",
        allowClear: true,
        size: "large",
        suffixIcon: /*#__PURE__*/React.createElement(Icon, {
          component: SvgLower$1
        })
      }, this.props), {}, {
        onChange: this.onChange
      }));
    }
  }]);

  return KtsTreeSelect;
}(React.Component);

export { SearchGroup as AdvancedSearch, KtsForm, KtsTreeSelect, SdkConfig };



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components/dist/index.esm.js
// module id = 339
// module chunks = 0